export default {
  type: 'Auto',
  sections: [
    { id: 'auto1', title: 'Auto Insurance Introduction' },
    { id: 'htgbr', title: 'How to Get The Best Rate' },
    { id: 'coverage', title: 'Components and Coverage' },
    { id: 'auto2', title: 'Main Price Impacting Factors' }
  ],
  introData: {
    title: 'Auto Insurance Guide',
    paragraphs: [
      "Welcome to Insurance Express's auto insurance guide! We're dedicated to helping drivers protect their vehicles by offering the best coverage at affordable rates. With years of experience in the industry, we have the knowledge and expertise to help you understand the ins and outs of auto insurance.",
      "As a leading provider of auto insurance in our region, we have access to a variety of insurance markets, allowing us to offer a wide range of coverage options to our clients. In this guide, we'll explain what auto insurance is, the different types of policies available, and provide tips on how to get the best rate on your policy.",
      "Whether you're a first-time car owner or looking to switch your existing policy, we hope that this guide will provide you with the information you need to make an informed decision. So, let's get started!"
    ]
  },
  bestRateTips: [
    "Shop around: It's important to get quotes from multiple insurance providers to ensure you're getting the best rate. Use online comparison tools or work with an independent insurance agent who can help you navigate the market.",
    "Bundle policies: Many insurance companies offer discounts for customers who bundle their auto insurance policy with other types of insurance, such as home or life insurance.",
    "Increase your deductible: The higher your deductible (the amount you pay out of pocket before insurance kicks in), the lower your monthly premium will be.",
    "Maintain a good driving record: Safe drivers with no accidents or violations typically pay less for auto insurance.",
    "Take advantage of discounts: Many insurers offer discounts for good students, safety features, defensive driving courses, and more."
  ],
  briefGuide: 'Auto insurance is essential for protecting yourself financially in case of an accident or other vehicle damage. It not only covers damage to your car but also provides liability protection if you injure someone else or damage their property while driving.',
  coverageItems: [
    'What is auto insurance and why is it important',
    'Types of auto insurance coverage: liability, collision, comprehensive',
    'Understanding deductibles and limits',
    'Factors that affect auto insurance rates',
    'How to choose the right coverage for your needs',
    'What to do after an accident'
  ],
  additionalInfo: {
    overview: 'Auto insurance provides financial protection against physical damage to your vehicle and bodily injuries resulting from traffic accidents. Most states require drivers to have at least some auto insurance coverage.',
    sections: [
      {
        title: 'Types of auto insurance coverage:',
        paragraphs: [
          "Liability Insurance: Covers costs if you're responsible for an accident that injures another person or damages their property.",
          'Collision Coverage: Pays for damage to your car resulting from a collision with another car or object.',
          'Comprehensive Coverage: Covers damage to your car caused by events other than collisions, such as theft, vandalism, or natural disasters.'
        ]
      },
      {
        title: 'Understanding deductibles and limits:',
        paragraphs: [
          'Deductible: The amount you pay out of pocket before your insurance kicks in.',
          'Coverage limits: The maximum amount your policy will pay for a covered claim.'
        ]
      }
    ]
  },
  pricingFactors: {
    title: "Main Price Impacting Factors for Auto Insurance",
    description: "When comparing rates and coverages for auto insurance, it is important to keep in mind data points that Insurance Companies find most important when evaluating your rate.",
    factors: [
      {
        title: "Multi-Policy Discount",
        description: "It goes without saying, Insurance Companies like when you purchase more than one policy with them. Consider this when you are getting one policy, they may give a deeper discount by adding another.",
        imageUrl: "/images/productPageImages/multi.png"
      },
      {
        title: "Driving Record",
        description: "Your driving history significantly impacts your auto insurance rates. Accidents, speeding tickets, and DUIs can all lead to higher premiums for several years.",
        imageUrl: "/images/productPageImages/multi.png"
      },
      {
        title: "Vehicle Type",
        description: "The make, model, year, and safety features of your vehicle all affect your insurance costs. Expensive, high-performance vehicles typically cost more to insure than family sedans.",
        imageUrl: "/images/productPageImages/credit.png"
      },
      {
        title: "Age and Demographics",
        description: "Young drivers typically pay higher rates, while middle-aged drivers often receive the best rates. Your location, marital status, and even credit score can also impact your auto insurance premiums.",
        imageUrl: "/images/productPageImages/marital.png"
      }
    ]
  },
  relatedProducts: [
    {
      title: "Home Insurance",
      imageUrl: "@/assets/images/product-type-icons/homeInsurance.svg",
      link: "/products/homeinsurance"
    },
    {
      title: "Life Insurance",
      imageUrl: "@/assets/images/product-type-icons/lifeInsurance.svg",
      link: "/products/lifeinsurance"
    },
    {
      title: "Umbrella Insurance",
      imageUrl: "@/assets/images/product-type-icons/lifeInsurance.svg", // Replaced missing umbrella icon
      link: "/products/umbrellainsurance"
    }
  ],
  ctaText: "(Home, Life, Umbrella, etc.)"
}; 